/**
 * readGatewayLane — extracts gateway-owned state from current settings.
 *
 * In the current architecture, gateway-owned settings are already in Redux
 * (loaded by the legacy settings flow). This reader normalizes them into
 * the lane shape expected by the composer.
 *
 * Gateway owns: Settings V2, interface configuration, selected experience.
 * This lane will shrink as ownership is unified to plugin-owned state.
 *
 * @param {object} settings - Gateway/Redux settings state
 * @returns {object} Normalized gateway lane result
 */

// ---------------------------------------------------------------------------
// Mode normalization: internal names → canonical StorefrontMode values
// ---------------------------------------------------------------------------

const MODE_MAP = {
  unified: 'widget',
  fullpage: 'combined',
  classic: 'classic',
  widget: 'widget',
  combined: 'combined',
};

function normalizeMode(raw) {
  if (!raw) return null;
  return MODE_MAP[raw] || null;
}

// ---------------------------------------------------------------------------
// Main reader
// ---------------------------------------------------------------------------

export function readGatewayLane({
  isFetched = false,
  selectedExperience = null,
  searchVisible = false,
} = {}) {
  return {
    available: isFetched,
    mode: normalizeMode(selectedExperience),
    searchVisible: !!searchVisible,
  };
}
